import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

// 样式
import './assets/scss/base.scss'
import './assets/scss/custom.scss'

// UI 组件库
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// Swiper 轮播
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

// 视频播放
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)

// 图片懒加载
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

// 国际化
import i18n from './lang'

Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()

// Axios 配置
axios.defaults.timeout = 5000
axios.defaults.baseURL = ''
Vue.prototype.$http = axios

// 图片服务器地址
Vue.prototype.imgserver = ''

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')